module.exports = __webpack_public_path__ + "img/1516018378.c0c4bdc1.jpg";